/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useDispatch } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

// Icons
import { Close } from 'icons/Tools_Interface';

// Actions
import { setClose, setSecondClose } from 'store/ducks/dialogs/actions';

// Styles
import useStyles from './modalTemplate.styles';

interface ModalTemplateProps {
  hideCloseIcon?: boolean;
  handleClose?: () => void;
  isSecond?: boolean;
  header?: React.ReactNode | React.ReactElement;
  title?: React.ReactNode | React.ReactElement;
  classes?: {
    root?: string;
    container?: string;
    closeIconContainer?: string;
    closeIcon?: string;
  };
}

type Props = ModalTemplateProps;

const ModalTemplate: React.FunctionComponent<Props> = ({
  hideCloseIcon,
  handleClose,
  header,
  title,
  classes,
  children,
  isSecond,
}) => {
  const { root, container } = useStyles();
  const dispatch = useDispatch();

  return (
    <>
      {!hideCloseIcon && (
        <Grid
          className={classes?.closeIconContainer}
          container
          justifyContent={`${title ? 'space-between' : 'flex-end'}`}>
          {title && (
            <Typography style={{ marginTop: 8 }} variant='h5'>
              {title}
            </Typography>
          )}
          <IconButton
            onClick={() => {
              if (handleClose instanceof Function) handleClose();
              else dispatch(isSecond ? setSecondClose({}) : setClose({}));
            }}
            className={classes?.closeIcon}>
            <Close width={12} height={12} />
          </IconButton>
        </Grid>
      )}

      {hideCloseIcon && header && <>{header}</>}

      <Box className={[root, classes?.root].join(' ')}>
        <Box
          className={[container, classes?.container].join(' ')}
          component='div'>
          {children}
        </Box>
      </Box>
    </>
  );
};

export { ModalTemplate };
export default ModalTemplate;
